"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopoverFooter: function() {
        return _TeachingPopoverFooter.TeachingPopoverFooter;
    },
    renderTeachingPopoverFooter_unstable: function() {
        return _renderTeachingPopoverFooter.renderTeachingPopoverFooter_unstable;
    },
    teachingPopoverFooterClassNames: function() {
        return _useTeachingPopoverFooterStylesstyles.teachingPopoverFooterClassNames;
    },
    useTeachingPopoverFooterStyles_unstable: function() {
        return _useTeachingPopoverFooterStylesstyles.useTeachingPopoverFooterStyles_unstable;
    },
    useTeachingPopoverFooter_unstable: function() {
        return _useTeachingPopoverFooter.useTeachingPopoverFooter_unstable;
    }
});
const _TeachingPopoverFooter = require("./TeachingPopoverFooter");
const _renderTeachingPopoverFooter = require("./renderTeachingPopoverFooter");
const _useTeachingPopoverFooter = require("./useTeachingPopoverFooter");
const _useTeachingPopoverFooterStylesstyles = require("./useTeachingPopoverFooterStyles.styles");
